import { Moment } from "moment";
import Utils from "../utils";
import { SyncModel, SyncDataModel, DataModel } from "./syncModel";
import { InternationalisationService } from "../../forked/angular-internationalisation";
import { IProductViewModel, IItemTagViewModel } from "./product.facade";
import { UsingType, ProductViewModel } from "./product.model";
import { IItemGoup } from "./item_group.model";
import { ContentType, ImageOrientation, TranslationContentType, YourAPPProductType } from "../contentTypes";
import { WebShopMode } from "../../services/IWebShopService";
import { CoreLanguageManager } from "../../services/ILanguageManager";
import { environment } from "../../../../environments/environment";

export class RecipelinkingViewModel implements IProductViewModel {

  public get is_recipe_linking(): boolean {
    return true;
  }

  private _model: RecipeLinkingDataModel;

  public location: number; //location wird bei der RecipeLinking die aktuelle location sein

  public get id(): number {
    return this._model.id;
  }
  public get artikelNo(): number {
    return this._model.item_number;
  }
  public get free_item_nr(): number {
    return +(this._model.free_item_number);
  }
  public get product_id(): number {
    return -(this._model.id); // Rezepturverkettungen haben selbst keine ProductID
  }
  public get usingtype(): number {
    return UsingType.Standart;
  }
  public isInGroup(item_group: IItemGoup): boolean {
    return this._model.isInGroup(ContentType.Item_Group, item_group.id);
  }
  public get label(): string {
    const _label = InternationalisationService.locale === "de" || Utils.IsNullOrWhiteSpace(this._model.name_en) ? this._model.name_de : this._model.name_en;
    if (YourAPPProductType.sot === environment.producttype) {
      return CoreLanguageManager.translate(TranslationContentType.Article_Bontext, this._model.id, _label);
    }
    else {
      return _label;
    }
  }

  public get heading(): string {
    const _headline = InternationalisationService.locale === "de" || Utils.IsNullOrWhiteSpace(this._model.headline_en) ? this._model.headline_de : this._model.headline_en;
    if (YourAPPProductType.sot === environment.producttype) {
      return CoreLanguageManager.translate(TranslationContentType.RecipeLinking_Heading, this._model.id, _headline);
    }
    else {
      return _headline;
    }
  }

  public get hasExtras(): boolean {
    return true; // Rezepturverkettungen bieten die Rezepturen zur weiteren Auswahl an
  }
  public get hasImage(): boolean {
    return this._model.last_image_update_at_hms > -1;
  }
  public get imageUrl(): string {
    if (this.hasImage)
      return ContentType.RecipeLinking + "/" + this._model.id + "_photo_" + ImageOrientation.Landscape + "/" + this._model.last_image_update_at_ymd + "/" + this._model.last_image_update_at_hms;
    else
      return "";
  }

  public get details_de(): string {
    return this._model.details_de;
  }

  public get details_en(): string {
    return this._model.details_en;
  }

  public get model(): RecipeLinkingDataModel {
    return this._model;
  }

  private _products: ProductViewModel[];
  public get products(): ReadonlyArray<ProductViewModel> {
    return this._products;
  }

  private _dislikeProducts: ProductViewModel[] = [];
  public get dislikeProducts(): ReadonlyArray<ProductViewModel> {
    return this._dislikeProducts;
  }

  private _hide_product_ids: number[];
  public get hide_product_ids(): ReadonlyArray<number> {
    return this._hide_product_ids;
  }

  public itemTags: IItemTagViewModel[];
  public amountOfLikedTags: number;
  /** Wenn false, so muss der schedule_hint angezeigt werden */
  public availible: boolean;
  /** Zeitsteuerungs Hinweis */
  public schedule_hint: string;

  /**
   * @param location aktueller standort
   * @param model Rezepturverlinkung
   * @param likedTagIds Ids der gelikten ArtikelTags
   * @param products Alle Artikel
   */
  public constructor(location: number, model: RecipeLinkingDataModel, likedTagIds: number[], dislikeIds: number[], products: ProductViewModel[], sortFunction: (a: IProductViewModel, b: IProductViewModel) => number) {
    const me = this;
    me.location = location;
    me._model = model;

    const subProductIDs = model.products.map(product => product.product_id);

    me._dislikeProducts = products.filter(p =>
      p.itemTags.some(tag => dislikeIds.includes(tag.id))
    );

    // Rezepturverlinkungsartikel die nicht versteckt sind
    me._products = products
      .filter(product => subProductIDs.includes(product.product_id) && !product.scheduler.hide)
      .filter(product =>
        !product.itemTags || !product.itemTags.some(tag => dislikeIds.indexOf(tag.id) !== -1)
      )
      .sort(sortFunction);



    me._hide_product_ids = model.products.filter(product => product.hide).map(product => product.product_id);

    // ermitteln der ArtikelTags und Verfügbarkeit aus den Rezepturen
    me.itemTags = [];
    let some_availible = false;
    me.schedule_hint = "";
    me._products.forEach(product => {
      product.itemTags.forEach(itemTag => {
        if (me.itemTags.findIndex(tag => tag.id == itemTag.id) == -1) {
          me.itemTags.push(itemTag);
        }
      });
      some_availible = some_availible || product.availible;
      if (!product.availible && me.schedule_hint == "") {
        me.schedule_hint = product.schedule_hint;
      }
    });
    me.availible = some_availible;

    me.amountOfLikedTags = 0;
    me.itemTags.forEach(itemTag => likedTagIds.forEach((likedTagId) => likedTagId === itemTag.id ? me.amountOfLikedTags++ : ""));
  }
}

// Requests
export class RecipeLinkingsSyncModel extends SyncModel {
}

// Responses
export class RecipeLinkingDataModel extends DataModel {
  public get DM_Key(): number | string { return this.id; }
  public id: number;

  public use_sot: boolean;
  public use_shop: boolean;
  public item_number: number;
  public free_item_number: string;
  public name_de: string;
  public name_en: string; // todo remove and use only core_language_manager
  public details_de: string;
  public details_en: string;// todo remove and use only core_language_manager
  public headline_de: string;
  public headline_en: string;
  public last_image_update_at_ymd: number;
  public last_image_update_at_hms: number;
  public sot_ordertype_inhouse: boolean;
  public sot_ordertype_takeaway: boolean;
  public shop_ordertype_browsing: boolean;
  public shop_ordertype_takeaway: boolean;
  public shop_ordertype_delivery: boolean;
  public shop_ordertype_inhouse: boolean;
  public shop_ordertype_retail: boolean;
  /** Prüfung ob in dem entsprechendem Webshop Mode/Ordertype die Rezepturvertkettung angeboten wird */
  public isInWebShopMode(mode: WebShopMode): boolean {
    if (mode == WebShopMode.Viewing) {
      return this.shop_ordertype_browsing;
    } else if (mode == WebShopMode.TakeAway) {
      return this.shop_ordertype_takeaway;
    } else if (mode == WebShopMode.Delivery) {
      return this.shop_ordertype_delivery;
    } else if (mode == WebShopMode.OrderToTable) {
      return this.shop_ordertype_inhouse;
    } else if (mode == WebShopMode.Retail) {
      return this.shop_ordertype_retail;
    } else {
      return false;
    }
  }
  public products: RecipeLinkingProduct[];
  public groups: RecipeLinkingGroup[];
  /** Prüfung ob die Rezepturverlinkung in der Gruppe ist */
  public isInGroup(item_group_type: ContentType.Item_Group | ContentType.SOTItemGroup, item_group_id: number): boolean {
    return this.groups.findIndex(group => group.content_type == item_group_type && group.content_id == item_group_id) > -1;
  }
  public deleted: boolean;
  public change_by: number;
  public change_at_ymd: number;
  public change_at_hms: number;
  public get change_at(): Moment {
    return Utils.GetMomentFromInt(this.change_at_ymd, this.change_at_hms);
  }
}

export class RecipeLinkingProduct {
  public product_id: number;
  public hide: boolean;
}
export class RecipeLinkingGroup {
  public content_type: number;
  public content_id: number;
}

export class RecipeLinkingsSyncDataModel extends SyncDataModel {
  public recipe_linkings: RecipeLinkingDataModel[];
  public get models(): DataModel[] { return this.recipe_linkings; }
  public DeserializeType(): void {
    this._DeserializeType(RecipeLinkingDataModel);
  }
}
